import React, { PureComponent } from 'react';
import Cluster from 'points-cluster';
import _ from 'lodash';
import { translate } from 'react-i18next';
import Tether from 'tether';

import TransitionGroupMarker from 'common/components/core/markers/TransitionGroupMarker';
import LatLngUtils from 'common/utils/LatLngUtils';
import MapUtil from 'common/utils/MapUtil';
import { MarkerType } from 'common/enums/MapEnum';
import { memoized } from 'common/utils/Memoizer';
import GeocodeEditUtils from 'common/utils/GeocodeEditUtils';

export const MapWithClusteringfactory = (GMap, ClusterMarker, SpiderMarker) => {
    class MapWithClustering extends PureComponent {
        constructor(props) {
            super(props);
            this.getSpiderMarkers = this.getSpiderMarkers.bind(this);
            this.getBBoxforMap = this.getBBoxforMap.bind(this);
            this.latLngToClusterMap = this.getLatLngToClusterMap(props);
            this.previousLatLngToClusterMap = null;
            this.state = { openSpiderKey: null };
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.map) {
                if (!!nextProps.children && !this.props.children) {
                    var latLngs = this.getLatLngs(nextProps.children);
                    var bounds = LatLngUtils.getBoundsFromLatLngs(latLngs);
                    nextProps.map.fitBounds(bounds);
                }
            }

            this.previousLatLngToClusterMap = this.latLngToClusterMap;
            this.latLngToClusterMap = this.getLatLngToClusterMap(nextProps);
            this.latLngToPointsMap = this.getLatLngToPointsMap(nextProps);
        }

        componentWillUnmount() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }

        SPIDERYFY_ZOOM_LEVEL = 17;
        DEFAULT_BOUNDS = {
            bounds: {
                nw: { lat: 85, lng: -180 },
                se: { lat: -85, lng: 180 }
            },
            zoom: 2
        };

        isPointPartOfAnySpider(latLng) {
            var { child, ...newLatLng } = latLng; // eslint-disable-line no-unused-vars
            if (!this.props.map) {
                return false;
            }
            var latLngList = this.latLngToPointsMap
                ? this.latLngToPointsMap[JSON.stringify(newLatLng)]
                : null;
            if (!latLngList) {
                // If Null -> Hasn't been added to cluster.
                return true;
            }
            return latLngList.length > 1;
        }

        getClusterColorObject = points => {
            const { overrideClusterColor } = this.props;
            if (overrideClusterColor) {
                var overridenClusterColor = overrideClusterColor(points);
                if (overridenClusterColor) {
                    return overridenClusterColor;
                }
            }
        };

        getClusterColor = points => {
            const {
                overrideClusterColor,
                overrideClusterConfidenceColor,
                shouldShowOriginalColor
            } = this.props;
            if (overrideClusterColor) {
                const overridenClusterColor = overrideClusterColor(points);
                if (overridenClusterColor) {
                    return overridenClusterColor.name;
                }
            }
            return GeocodeEditUtils.getClusterColorByConfidence({
                points,
                shouldShowOriginalColor,
                overrideClusterConfidenceColor
            });
        };

        @memoized()
        getClusterMarkers(clusters) {
            const {
                theme,
                map,
                showPopupOnClick,
                handleLocationSelect,
                disableHidePopupIfChildSelected,
                t
            } = this.props;
            const { openSpiderKey } = this.state;
            if (!clusters) return null;
            return clusters.map((cluster, index) => {
                if (cluster.numPoints === 1) {
                    var childProps = cluster.points[0].child.props;
                    return (
                        <TransitionGroupMarker
                            key={childProps.id}
                            {...childProps}
                        >
                            {React.cloneElement(cluster.points[0].child, {
                                latLngToClusterMap: this.latLngToClusterMap,
                                previousLatLngToClusterMap: this
                                    .previousLatLngToClusterMap
                            })}
                        </TransitionGroupMarker>
                    );
                } else {
                    const allChildrenDisabled = MapUtil.areAllChildrenDisabled(
                        cluster
                    );
                    // #Cluster Icon
                    if (this.isClusterSpider(cluster)) {
                        var bboxMap = this.getBBoxforMap();
                        var pointsList = cluster.points;
                        var key = `spider${pointsList[0].child.props.id}`;

                        return (
                            <TransitionGroupMarker
                                key={key}
                                lat={cluster.y}
                                lng={cluster.x}
                            >
                                <SpiderMarker
                                    key={key}
                                    id={key}
                                    theme={theme}
                                    lat={cluster.y}
                                    lng={cluster.x}
                                    color={this.getClusterColor(pointsList)}
                                    clusterCount={pointsList.length}
                                    markerLabel={pointsList.length}
                                    map={map}
                                    bboxMap={bboxMap}
                                    isPopupAttached={openSpiderKey === key}
                                    showPopup={this.handleOpenSpider}
                                    hidePopup={this.handleHideSpider}
                                    handleLocationSelect={handleLocationSelect}
                                    cluster={pointsList}
                                    showPopupOnClick={showPopupOnClick}
                                    isDisabled={allChildrenDisabled}
                                    tooltipText={t('clickToOpen')}
                                    disableHidePopupIfChildSelected={
                                        disableHidePopupIfChildSelected
                                    }
                                />
                            </TransitionGroupMarker>
                        );
                    }

                    return (
                        <TransitionGroupMarker
                            key={`cluster${index}`}
                            lat={cluster.y}
                            lng={cluster.x}
                        >
                            <ClusterMarker
                                key={`cluster${index}`}
                                lat={cluster.y}
                                lng={cluster.x}
                                theme={theme}
                                color={this.getClusterColor(cluster.points)}
                                markerLabel={cluster.numPoints}
                                clusterCount={cluster.numPoints}
                                isDisabled={allChildrenDisabled}
                                map={this.props.map}
                                cluster={cluster}
                                isCluster
                                latLngToClusterMap={this.latLngToClusterMap}
                                previousLatLngToClusterMap={
                                    this.previousLatLngToClusterMap
                                }
                                tooltipText={t('clickToZoom')}
                            />
                        </TransitionGroupMarker>
                    );
                }
            });
        }

        isClusterSpider(cluster) {
            // In Spider All markers should have same latLng;
            var isSpider = true;
            var { points } = cluster;
            if (points.length < 2) return false;
            var [firstMarker] = points;
            var spiderCenter = JSON.stringify({
                lat: firstMarker.lat,
                lng: firstMarker.lng
            });
            for (var i = 0; i < points.length; i++) {
                var point = cluster.points[i];
                if (
                    JSON.stringify({ lat: point.lat, lng: point.lng }) !==
                    spiderCenter
                ) {
                    isSpider = false;
                    break;
                }
            }
            return isSpider;
        }

        handleOpenSpider = key => {
            const { handleOpenSpider } = this.props;
            handleOpenSpider && handleOpenSpider(key);
            this.setState({ openSpiderKey: key });
        };

        handleHideSpider = key => {
            this.setState({ openSpiderKey: null });
            const { handleHideSpider } = this.props;

            handleHideSpider && handleHideSpider(key);
        };

        getSpiderMarkers = () => {
            const {
                theme,
                getSpiderMarkerIcon,
                disableVirtualization,
                disableSpiderMarkerDrag,
                overrideMarkerSpidering,
                getCustomSpiderKey,
                disableHidePopupIfChildSelected,
                map,
                showPopupOnClick,
                handleLocationSelect
            } = this.props;
            const { openSpiderKey } = this.state;
            var bboxMap = this.getBBoxforMap();
            return Object.keys(this.latLngToPointsMap)
                .map(latLng => {
                    var pointsList = this.latLngToPointsMap[latLng];
                    //overrider the spidering logic from parent for the particular set

                    if (overrideMarkerSpidering) {
                        const overridenMarkers = overrideMarkerSpidering(
                            pointsList
                        );
                        if (overridenMarkers) {
                            return overridenMarkers;
                        }
                    }
                    if (pointsList.length === 1) {
                        if (pointsList[0].child.props.shouldFilterFromCluster) {
                            return null;
                        }
                        return (
                            <TransitionGroupMarker
                                key={pointsList[0].child.props.id}
                                lat={pointsList[0].child.props.lat}
                                lng={pointsList[0].child.props.lng}
                            >
                                {pointsList[0].child}
                            </TransitionGroupMarker>
                        );
                    } else {
                        var latLngsObject = JSON.parse(latLng);
                        var key = getCustomSpiderKey
                            ? getCustomSpiderKey(latLngsObject)
                            : `spider${pointsList[0].child.props.id}`;
                        const allChildrenDisabled = MapUtil.areAllChildrenDisabled(
                            pointsList
                        );
                        return (
                            <TransitionGroupMarker
                                {...SpiderMarker.defaultProps}
                                label={
                                    getSpiderMarkerIcon
                                        ? getSpiderMarkerIcon(pointsList)
                                        : pointsList.length
                                }
                                color={this.getClusterColorObject(pointsList)}
                                key={key}
                                isDisabled={allChildrenDisabled}
                                lat={latLngsObject.lat}
                                lng={latLngsObject.lng}
                            >
                                <SpiderMarker
                                    key={key}
                                    isSpiderMarker
                                    theme={theme}
                                    lat={latLngsObject.lat}
                                    lng={latLngsObject.lng}
                                    id={key}
                                    disableSpiderMarkerDrag={
                                        disableSpiderMarkerDrag
                                    }
                                    disableHidePopupIfChildSelected={
                                        disableHidePopupIfChildSelected
                                    }
                                    color={this.getClusterColor(pointsList)}
                                    clusterCount={pointsList.length}
                                    markerIcon={
                                        getSpiderMarkerIcon
                                            ? getSpiderMarkerIcon(pointsList)
                                            : null
                                    }
                                    markerLabel={
                                        getSpiderMarkerIcon
                                            ? null
                                            : pointsList.length
                                    }
                                    map={map}
                                    bboxMap={bboxMap}
                                    isPopupAttached={openSpiderKey === key}
                                    showPopup={this.handleOpenSpider}
                                    hidePopup={this.handleHideSpider}
                                    handleLocationSelect={handleLocationSelect}
                                    showPopupOnClick={showPopupOnClick}
                                    cluster={pointsList}
                                />
                            </TransitionGroupMarker>
                        );
                    }
                })
                .filter(
                    child =>
                        disableVirtualization ||
                        (!!child &&
                            map &&
                            map.getBounds().contains(this.getLatLng(child)))
                );
        };

        getBBoxforMap() {
            var element = this.props.map.getDiv();
            return element.getBoundingClientRect();
        }

        getLatLngToClusterMap(props) {
            const { enableClustering } = props;
            var latLngToClusterMap = {};
            if (!enableClustering) {
                return latLngToClusterMap;
            }
            var clusters = this.getClusters(props);
            if (!clusters) return null;
            clusters.forEach(cluster => {
                cluster.points.forEach(point => {
                    var latLng = {
                        lat: point.lat,
                        lng: point.lng
                    };
                    latLngToClusterMap[JSON.stringify(latLng)] = cluster;
                });
            });
            return latLngToClusterMap;
        }

        getLatLngToPointsMap(props) {
            const { getLatLngToPointsMap } = this.props;
            if (getLatLngToPointsMap) {
                return getLatLngToPointsMap(
                    this.getLatLngs(this.getFlattenChildren(props))
                );
            }
            var latLngToPointsMap = {};
            this.getLatLngs(this.getFlattenChildren(props)).forEach(point => {
                if (
                    !point.child.props.isArchived ||
                    !point.child.props.doNotSpider
                ) {
                    var latLng = {
                        lat: point.lat,
                        lng: point.lng
                    };
                    if (LatLngUtils.isValid(latLng)) {
                        if (latLngToPointsMap[JSON.stringify(latLng)]) {
                            latLngToPointsMap[JSON.stringify(latLng)].push(
                                point
                            );
                        } else {
                            latLngToPointsMap[JSON.stringify(latLng)] = [point];
                        }
                    }
                }
            });
            return latLngToPointsMap;
        }

        @memoized()
        getLatLngs(markers) {
            if (!markers) return null;
            return markers.map(marker => {
                return this.getLatLng(marker);
            });
        }

        getLatLng(marker) {
            return {
                lat: marker.props.lat,
                lng: marker.props.lng,
                child: marker
            };
        }

        @memoized()
        getClusterer(latLngs) {
            if (!latLngs) return null;
            return Cluster(latLngs);
        }

        getBounds(map) {
            /*
          This method returns bounds of the map in a format that clusterer expects .
          map.getBounds returns north west south and east as bounds where as cluster
          expects bounds in the format of nw and south east corner.
          Clustering will work irrsepective of whether map has been loaded or not .
          Thus, passing entire world as Bounds if map isn't loaded .
          */

            // Its possible the getBounds on map is evaluate before the fitToBounds
            // happen and hence an error can occur in map.getBounds().toJSON() hence checking for
            // undefined with map.getBounds()

            if (!map || !map.getBounds()) return this.DEFAULT_BOUNDS;
            var boundsJson = map.getBounds().toJSON();
            return {
                bounds: {
                    nw: {
                        lat: boundsJson.north,
                        lng: boundsJson.west
                    },
                    se: {
                        lat: boundsJson.south,
                        lng: boundsJson.east
                    }
                },
                zoom: map.getZoom()
            };
        }

        getClusters(props) {
            var bounds = this.getBounds(props.map);
            var filteredMarkers = this.getMarkersIncludedInCluster(props);
            var clusterer = this.getClusterer(this.getLatLngs(filteredMarkers));
            if (!clusterer || !props.map) return null;
            else {
                return clusterer(bounds);
            }
        }

        getFlattenChildren(props) {
            return _.flattenDeep(props.children);
        }

        getMarkersNotInCluster(props) {
            if (!this.getFlattenChildren(props)) {
                return [];
            }
            var notInCluster = this.getFlattenChildren(props).filter(child => {
                if (!child) {
                    return true;
                }
                var latLng = this.getLatLng(child);
                if (!LatLngUtils.isValid(latLng)) {
                    return true;
                }
                if (
                    child.props.isSelected &&
                    !child.props.isArchived &&
                    this.latLngToClusterMap
                ) {
                    var { lat, lng } = latLng;
                    var cluster = this.latLngToClusterMap[
                        JSON.stringify({ lat, lng })
                    ];
                    if (cluster && cluster.numPoints > 1) {
                        return !this.isClusterSpider(cluster);
                    }
                }
                return (
                    child.props.isArchived ||
                    child.props.doNotSpider ||
                    (child.props.shouldFilterFromCluster &&
                        !this.isPointPartOfAnySpider(latLng))
                );
            });
            return notInCluster;
        }

        getMarkersIncludedInCluster(props) {
            if (!this.getFlattenChildren(props)) {
                return [];
            }
            return _.difference(
                this.getFlattenChildren(props),
                this.getMarkersNotInCluster(props)
            );
        }

        _distanceToMouseKoef = markerProps => {
            if (markerProps.markerType === MarkerType.NON_HOVERABLE) {
                return Number.MAX_VALUE;
            }
            // because of marker non symmetric,
            // we transform it central point to measure distance from marker circle center
            // you can change distance function to any other distance measure

            // and i want that hover probability on markers with text ==== 'A' be greater than others
            // so i tweak distance function (for example it's more likely to me that user click on 'A' marker)
            // another way is to decrease distance for 'A' marker
            // this is really visible on small zoom values or if there are a lot of markers on the map
            var distanceKoef = 1;
            if (markerProps.isArchived) {
                distanceKoef = 1.1;
            } else if (
                markerProps.isSelected ||
                markerProps.shouldFilterFromCluster
            ) {
                distanceKoef = 0.9;
            }
            // it's just a simple example, you can tweak distance function as you wish
            return distanceKoef;
        };

        _distanceToMouse = (markerPos, mousePos, markerProps) => {
            var { x, y } = markerPos;
            const distanceKoef = this._distanceToMouseKoef(markerProps);
            // it's just a simple example, you can tweak distance function as you wish
            return (
                distanceKoef *
                Math.sqrt(
                    (x - mousePos.x) * (x - mousePos.x) +
                        (y - mousePos.y) * (y - mousePos.y)
                )
            );
        };

        getMarkersNotInSpider() {
            var markersNotToBeIncludedInCluster = this.getMarkersNotInCluster(
                this.props
            );
            return markersNotToBeIncludedInCluster.filter(marker => {
                var latLng = this.getLatLng(marker);
                return (
                    marker.props.shouldFilterFromCluster ||
                    marker.props.doNotSpider ||
                    marker.props.isArchived ||
                    !this.isPointPartOfAnySpider(latLng)
                );
            });
        }

        onChange = (...args) => {
            const { onChange } = this.props;
            this._updateTetherPositions();
            onChange && onChange(...args);
        };

        onZoomAnimationEnd = () => {
            this._updateTetherPositions();
            const { onZoomAnimationEnd } = this.props;
            onZoomAnimationEnd?.();
        };

        _updateTetherPositions = () => {
            // done to position the child Tether Element to Parent Tether if it exists since the
            // positions of the child are calculated first and then the parent.
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                Tether.position();
            }, 100);
        };

        render() {
            var { enableClustering, map, mapChildren, ...other } = this.props;
            var clusterMarkers = [];
            var markersNotInCluster = [];
            if (map) {
                var zoomLevel = map.getZoom();
                var isSpiderify = zoomLevel >= this.SPIDERYFY_ZOOM_LEVEL;
                if (isSpiderify || !enableClustering) {
                    clusterMarkers = this.getSpiderMarkers();
                    markersNotInCluster = this.getMarkersNotInSpider();
                } else {
                    var clusters = this.getClusters(this.props);
                    clusterMarkers = clusters
                        ? this.getClusterMarkers(clusters)
                        : [];
                    markersNotInCluster = this.getMarkersNotInCluster(
                        this.props
                    );
                }
            }
            const mapChildrenElements = mapChildren ? mapChildren : [];
            return (
                <GMap
                    {...other}
                    onZoomAnimationEnd={this.onZoomAnimationEnd}
                    onChange={this.onChange}
                    distanceToMouse={this._distanceToMouse}
                    distanceToMouseKoef={this._distanceToMouseKoef}
                >
                    {clusterMarkers}
                    {mapChildrenElements}
                    {markersNotInCluster}
                </GMap>
            );
        }
    }
    return translate('translations', { withRef: true })(MapWithClustering);
};
